import { useState } from "react";
import RemoteListPicker from "../mobiledpi/RemoteListPicker";
import { api } from "../common/api";
import { Button, Form, List, NavBar, Space } from "antd-mobile";
import { useLoaderData, useNavigate } from "react-router";
const items = (record) => [
  {
    label: "Categoria",
    value: record.type?.name,
  },
  {
    label: "Codice seriale",
    value: record.serialCode,
  },
  {
    label: "Descrizione",
    value: record.description,
  },
  {
    label: "Stato",
    value: record.assignment ? "Assegnato" : "Disponibile",
  },
  {
    label: "Assegnato a",
    show: !!record.assignment,
    value: record.assignment && record.assignment.employee.fullName,
  },
];
export default function () {
  const equipment = useLoaderData();
  const navigate = useNavigate();

  return (
    <Space direction="vertical" block style={{ "--gap": "16px" }}>
      <NavBar onBack={() => navigate("..", { replace: true })} style={{ background: "#FFF" }}>
        {equipment.description}
      </NavBar>
      <List header={"Dettagli attrezzatura"}>
        {items(equipment)
          .filter((x) => (x.show != null ? x.show : true))
          .map((key, index) => (
            <List.Item key={index} title={key.label} show={key.show}>
              {key.value}
            </List.Item>
          ))}
      </List>
      <div style={{ padding: 10 }}>
        {equipment.id && !equipment.assignment && (
          <Button block type="submit" color="primary" onClick={() => navigate("assign")}>
            Consegna
          </Button>
        )}
        {equipment.id && equipment.assignment && (
          <Button block type="submit" color="warning" onClick={() => navigate("unassign")}>
            Restituisci
          </Button>
        )}
      </div>
    </Space>
  );
}
